import * as React from 'react';
import styled from '@emotion/styled';
import { SectionContent } from './section';

interface ExtendedBgProps {
  children: React.ReactNode;
  backgroundColor: string;
}

const ExtendedBg = ({ children, backgroundColor }: ExtendedBgProps) => (
  <Background backgroundColor={backgroundColor}>
    <SectionContent>{children}</SectionContent>
  </Background>
);

const Background = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100vw;
  display: flex;
  justify-content: center;
`;

export default ExtendedBg;
